import { sendWsMessage } from '../../connection/create-ws-bridge.js';
import { installLocalAgentOnBridge } from '../../agents/install/install-local-agent.js';
import type { BridgeMessageHandler } from '../message-router.js';

export const handleInstallAgentMessage: BridgeMessageHandler<'install_agent'> = (msg, deps) => {
  const processId = typeof msg.processId === 'string' ? msg.processId : '';
  const agentId = typeof msg.agentId === 'string' ? msg.agentId : '';
  const tokenId = typeof msg.tokenId === 'string' ? msg.tokenId : '';
  const agentType = typeof msg.agentType === 'string' ? msg.agentType : '';
  const authToken = typeof msg.authToken === 'string' ? msg.authToken : '';
  if (!processId || !agentId || !tokenId || !agentType || !authToken) return;

  void (async () => {
    const socket = deps.getWs();
    const report = (step: string, message: string, logOutput?: string) => {
      if (socket) {
        sendWsMessage(socket, {
          type: 'install_agent_progress',
          processId,
          agentId,
          tokenId,
          agentType,
          step,
          message,
          ...(logOutput ? { logOutput } : {}),
        });
      }
    };

    const result = await installLocalAgentOnBridge({
      agentType,
      authToken,
      onProgress: (message, logOutput) => report('agent_install_package', message, logOutput),
    });

    if (socket) {
      sendWsMessage(socket, {
        type: 'install_agent_result',
        processId,
        agentId,
        tokenId,
        agentType,
        success: result.success,
        error: result.error,
      });
    }
    if (result.success) {
      await deps.reportAutoDetectedAgents?.();
    }
    if (!result.success) {
      deps.log(`[Bridge service] Install agent failed: ${result.error ?? 'unknown'}`);
    }
  })();
};
